import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import './styles/colors.css';
import './styles/constants.css';
import './index.css';
import AuthRoutes from './routes/AuthRoutes';
import StudentRoutes from './routes/StudentRoutes';
import AuthProvider from './providers/AuthProvider';
import NotAuthProvider from './providers/NotAuthProvider';
import RequireAuth from './components/RequireAuth';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import { SidebarDrawerProvider } from './context/SidebarDrawerContext';
import { useTheme } from '@mui/material/styles';

function AppShell({ children, bare = false }) {
  return (
    <AuthProvider>
      <SidebarDrawerProvider>
        {!bare && (
          <>
            <Header />
            <Sidebar />
          </>
        )}
        {children}
      </SidebarDrawerProvider>
    </AuthProvider>
  );
}

const routerBasename = (process.env.PUBLIC_URL || '').replace(/\/$/, '');

function App() {
  const theme = useTheme();

  return (
    <main>
      <div className="App" style={{ backgroundColor: theme.palette.background.default }}>
        <BrowserRouter basename={routerBasename}>
          <Routes>
            <Route path="/" element={<Navigate to="/home" replace />} />
            {AuthRoutes().map((route, index) => (
              <Route key={`auth-${index}`} path={route.path} element={<NotAuthProvider>{route.element}</NotAuthProvider>} />
            ))}
            {StudentRoutes().map((route, index) => {
              const bare = ['/verify', '/onboarding'].includes(route.path);
              const page = route.authRequired ? <RequireAuth>{route.element}</RequireAuth> : route.element;
              return (
                <Route
                  key={`student-${index}`}
                  path={route.path}
                  element={<AppShell bare={bare}>{page}</AppShell>}
                />
              );
            })}
          </Routes>
        </BrowserRouter>
      </div>
    </main>
  );
}

export default App;
